import React from "react";

const LockSVG = () => {
  return (
    <svg
      width="78px"
      height="101px"
      viewBox="0 0 78 101"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="WG-Launch-State"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Web-Gallery-Password"
          transform="translate(-644.000000, -277.000000)"
        >
          <g id="Group-3" transform="translate(643.000000, 277.000000)">
            <g id="Lock-Icon" fill="#B7B7B7">
              <path
                d="M76.9373333,38.6790132 L60.5413333,38.6790132 L60.5465467,21.2259474 C60.5465467,21.070208 60.53092,20.9248611 60.5152933,20.9248611 C60.35384,9.86243737 51.19756,0.871045263 40.1032933,0.871045263 C29.04596,0.871045263 19.90996,9.81552553 19.6912933,20.8265189 C19.65484,20.9459116 19.6392133,21.0860757 19.6392133,21.2262397 L19.6392133,38.6793055 L3.06054667,38.6793055 C2.03972,38.6793055 1.21161333,39.5047014 1.21161333,40.5273397 L1.21161333,98.2794055 C1.21161333,99.3020704 2.04494667,100.12744 3.06054667,100.12744 L76.9405467,100.12744 C77.9613733,100.12744 78.79468,99.3020438 78.79468,98.2794055 L78.79468,40.5273397 C78.79468,39.5098711 77.9613467,38.6793055 76.9353467,38.6793055 L76.9373333,38.6790132 Z M23.344,21.6312763 C23.3752533,21.4859161 23.3960933,21.3509482 23.3960933,21.2211764 C23.3960933,12.0378843 30.8908933,4.57345276 40.0934267,4.57345276 C49.2964933,4.57345276 56.79076,12.0435988 56.79076,21.2211764 C56.79076,21.3509614 56.8063733,21.4859293 56.822,21.5015046 L56.822,38.6794783 L23.3526667,38.6846745 L23.344,21.6312763 Z M75.0786667,42.3748158 L75.0786667,96.4310789 L4.92266667,96.4310789 L4.92266667,42.3748158 L75.0786667,42.3748158 Z"
                id="Fill-1"
              ></path>
            </g>
            <g id="Group-2" transform="translate(33.333333, 57.144737)">
              <path
                d="M8.15433107,24.1621051 L8.1595444,12.4645961 C8.1595444,11.4471274 7.78069333,10.6217447 6.75988,10.6217447 C5.73905333,10.6217447 5.2205749,11.4471407 5.2205749,12.4645961 L5.2205749,24.1621051 C5.2205749,25.1795871 5.73386667,26.0049564 6.75468,26.0049564 C7.77549333,26.0049564 8.15433107,25.1795605 8.15433107,24.1621051 Z"
                id="Fill-2"
                fill="#B7B7B7"
              ></path>
              <ellipse
                id="Oval"
                stroke="#B7B7B7"
                stroke-width="2.7"
                fill-opacity="0"
                fill="#D8D8D8"
                fill-rule="nonzero"
                cx="6.66666667"
                cy="5.98026316"
                rx="6"
                ry="5.98026316"
              ></ellipse>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LockSVG;
